import { http } from "@/helpers/http";
import axios from 'axios';
// const baseUrl = "https://9goigu00q4.execute-api.us-east-1.amazonaws.com/dev/v1";
// const baseUrl = "https://ti1lcbkdxa.execute-api.us-east-1.amazonaws.com/dev/v1"; // sg
// const baseUrl = "http://localhost:3000/dev/v1";

const baseUrl = "/bills/v1";

export default {
  namespaced: true,
  state: {
    cancelToken: null,
    activeStatus: null,
  },
  getters: {
    activeStatus(state) {
      return state.activeStatus;
    }
  },
  mutations: {
    setActiveStatus(state, activeStatus) {
      state.activeStatus = activeStatus;
    },
    setCancelTokenSource(state, cancelToken) {
      state.cancelTokenSource = cancelToken;
    }
  },

  actions: {
    fetchBills({ state, commit, rootState }, payload) {
      if (state.cancelToken) {
        let stateTokenSource = state.cancelToken.source();
        stateTokenSource.cancel('Cancelled by client');
      }
      let token = axios.CancelToken;
      commit('setCancelTokenSource', token);
      http
        .get(baseUrl + "/bills", {
          params: {
            status: payload.status,
            ExclusiveStartKey: payload.LastEvaluatedKey,
            perPage: payload.perPage
          },
          cancelToken: state.cancelToken
        })
        .then((response) => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch((error) => {
          if (payload.callback) payload.callback(false);
        });
    },

    searchBills({ state, commit, rootState }, payload) {
      http
        .get(`${baseUrlV2}/bills/search?status=${payload.status}&column=${payload.column}&keyword=${payload.keyword}&salesAgents=${payload.salesAgent}&mode=${payload.mode || "normal"}`)
        .then((response) => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch((error) => {
          if (payload.callback) payload.callback(false);
        });
    },

    async fetchBillDetail({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.get(`${baseUrl}/bills/${payload.billNo}`)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async createBill({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.post(baseUrl + "/bills", payload.bill)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async updateBill({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.put(`${baseUrl}/bills/${payload.billNo}`, payload.bill)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async cancelBill({ state, commit, rootState }, payload) {
      try {
        await http.delete(`${baseUrl}/bills/${payload.billNo}`)
        return { status: true }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async updateBillStatus({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.put(`${baseUrl}/bills/${payload.billNo}/status`, { status: payload.status })
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    }
  }
};

